import React, { useState, useEffect, useContext } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import Autocomplete from '@mui/material/Autocomplete';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import axios from 'axios';
import Typography from '@mui/material/Typography';
import { NotificationManager } from 'react-notifications';
import CircularProgress from '@mui/material/CircularProgress';
import "./domain.css";
import { UserTypeContext } from "../../AppRoute";
import DataTable from '../../components/DataTable/DataTable';
import { useNavigate } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import UnauthorizedAccess from '../../components/UnauthorizedAccess/UnauthorizedAccess.js';


export default function Domain({ idContextTest }) {
    const history = useNavigate();
    const { userType, userIdType } = useContext(UserTypeContext);
    const jsonConfig = require("../../Config.json")
    const [modalIsOpen, setmodalIsOpen] = useState(false);
    const [modalIsEditopen, setmodalIsEditopen] = useState(false);
    const [isDataLoaded, setisDataLoaded] = useState(false);
    const [allDomain, setallDomain] = useState([]);
    const [modalDataForEdit, setmodalDataForEdit] = useState({});
    const [modalDataForAdd, setmodalDataForAdd] = useState({})
    const [apvBtn, setApvBtn] = useState(false);

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                if (userType === "Admin") {
                    await getAllDomain();
                } else {
                    setisDataLoaded(true)
                }
            } catch (error) {
                setisDataLoaded(true);
            } finally {
                setisDataLoaded(true);
            }
        }
        fetchAllData();
    }, [])
    const getAllDomain = async () => {

        try {
            const getAllDomainResponse = await axios.get(
                jsonConfig.apiUrl + "domains", {
                headers: {
                    "x-functions-key": jsonConfig.key,
                },
            }
            );
            if (getAllDomainResponse.status === 200) {
                setisDataLoaded(true);
                setallDomain(getAllDomainResponse.data.data)

            }
        } catch (error) {
            console.log(error);
        }

    }
    const openModal = () => {
        setmodalIsOpen(true)
    }
    const closeModal = () => {
        setmodalIsOpen(false);
        setmodalDataForAdd({})
    }
    const closeEditmodal = () => {
        setmodalIsEditopen(false)
    }
    const domainChangeHandlerForEdit = (e) => {
        var v = e.target.value
        setmodalDataForEdit(prevState => ({
            ...prevState,
            name: v,
        })
        )
    }
    const activeHandlerEdit = (e, value) => {
        if (value) {
            var v = value.isActive
            setmodalDataForEdit(prevState => ({
                ...prevState,
                isActive: v,
            })
            )
        }
        else {
            modalDataForEdit.isActive = ""
        }
    }
    const openEditmodal = async (e, id) => {
        try {
            const getDomainById = await axios.get(
                jsonConfig.apiUrl + "domains/" + id, {
                headers: {
                    "x-functions-key": jsonConfig.key,
                },
            }
            );
            setmodalDataForEdit(getDomainById.data.data)
            setmodalIsEditopen(true)
        } catch (error) {
            console.log(error);
        }
    }
    const updateDomain = async () => {
        setApvBtn(true);
        var domainEditData = {
            "name": modalDataForEdit.name?.trim(),
            "isActive": modalDataForEdit.isActive,
            "updatedBy": userIdType
        }
        if (!domainEditData.name || modalDataForEdit.isActive === "") {
            setApvBtn(false);
            return (
                NotificationManager.error('Please fill all the mandatory fields', 'Error', 10000)
            )
        }
        try {
            await axios.put(
                jsonConfig.apiUrl + "domains/" + modalDataForEdit.id, domainEditData, {
                headers: {
                    "x-functions-key": jsonConfig.key,
                },
            }
            );
            getAllDomain();
            NotificationManager.success('Domain updated', 'Success', 10000)
            setApvBtn(false);
            setmodalIsEditopen(false)
        } catch (error) {
            console.log(error);
            setApvBtn(false);
        }
    }
    const domainNamehandlerForadd = (e) => {
        var v = e.target.value
        setmodalDataForAdd(prevState => ({
            ...prevState,
            name: v,
        })
        )
    }
    const activeHandlerForAdd = (e, value) => {
        if (value) {
            setmodalDataForAdd(prevState => ({
                ...prevState,
                isActive: value.isActive,
            })
            )
        }
    }
    const activeHandlerAdd = (e, value) => {
        if (value === "") {
            setmodalDataForAdd(prevState => ({
                ...prevState,
                isActive: undefined,
            }))
        }
    }
    const addDomain = async () => {
        setApvBtn(true);
        var domainAddData = {
            "name": modalDataForAdd.name?.trim(),
            "isActive": modalDataForAdd.isActive,
            "createdBy": userIdType,
            "updatedBy": userIdType
        }
        if (!domainAddData.name || modalDataForAdd.isActive === undefined) {
            setApvBtn(false);
            return (
                NotificationManager.error('Please fill all the mandatory fields', 'Error', 10000)
            )
        }
        try {
            const adddomainResponse = await axios.post(
                jsonConfig.apiUrl + "domains", domainAddData, {
                headers: {
                    "x-functions-key": jsonConfig.key,
                },
            }
            );
            if (adddomainResponse.status === 200) {
                setApvBtn(false);
                return (
                    NotificationManager.error('The domain already exists in the system. Please use a different domain name', 'Error', 10000)
                )
            }
            NotificationManager.success('Domain added', 'Success', 10000)
            await getAllDomain();
            setApvBtn(false);
            closeModal()
        } catch (error) {
            console.log(error);
            setApvBtn(false);
        }
    }


    const v = [{ isActive: true },
    { isActive: false },
    ];
    const closeButton = {
        position: 'absolute',
        right: "7px",
        top: "12px",
        color: 'grey',
    };
    const btnGreen = {
        color: '#fff',
        backgroundColor: '#1885e6',
        border: 'none',
        padding: '7px 23px 7px 23px',
        float: 'right',
        marginTop: '20px',
        marginRight: '2em'
    };

    const activityOptions = [
        { label: 'All', value: '' },
        { label: 'True', value: 'true' },
        { label: 'False', value: 'false' }
    ]

    function isActiveFilterFn(row, columnId, filterValue) {
        if (!filterValue) return true; // no filter
        const rowValue = row.getValue(columnId);
        const filterValLower = filterValue.toLowerCase();
        if (filterValLower === 'true') return rowValue === true;
        if (filterValLower === 'false') return rowValue === false;
        return true;
    }

    const getIsActiveFilterValue = (column) => {
        const filterValue = column.getFilterValue();
        const activityOptions = [
            { label: 'All', value: '' },
            { label: 'True', value: 'true' },
            { label: 'False', value: 'false' }
        ];
        let value = activityOptions.find(opt => opt.value === filterValue);
        if (!value) {
            value = { label: 'All', value: '' };
        }
        return value;
    }

    let columns = [
        {
            accessorKey: "name",
            header: "Domain",
            size: 300,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: 'includesString',
        },
        {
            accessorKey: "isActive",
            header: "Is Active",
            size: 80,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: isActiveFilterFn,
            cell: ({ getValue }) => (getValue() ? "True" : "False"),
            Filter: ({ column }) => (
                <Autocomplete
                    disableClearable
                    className='isActiveFilter-autocomplete'
                    options={activityOptions}
                    value={getIsActiveFilterValue(column)}
                    onChange={(event, newValue) => {
                        column.setFilterValue(newValue ? newValue.value : '');
                    }}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            size="small"
                        />
                    )}
                    sx={{ width: '100%' }}
                />
            )
        },
        {
            id: "action",
            header: "Action",
            cell: ({ row }) => (
                <>
                    <Button
                        variant="contained"
                        color="primary"
                        className='edit-button-alltest-skill'
                        onClick={() => openEditmodal(row.original, row.original.id)}
                    >
                        Edit
                    </Button>
                </>
            ),
            size: 100,
            enableSorting: false,
            enableColumnFilter: false,
        },
    ]

    const goToDashboard = () => {
        history("/admin-home");
    };

    return (
        <>
            <div className='main_container_domain'>
                {!isDataLoaded ?
                    <div className="row padding_80 text-center">
                        <CircularProgress />
                    </div>
                    :
                    <>
                        {
                            userType === "Admin" ?
                                <>
                                    <Grid container spacing={3}  >
                                        <div className='container_domain'>
                                            <div className="communityHeader_manageUser ">
                                                <div className="goBackButton" onClick={(e) => goToDashboard(e)}>
                                                    <Tooltip title="Go Back to Dashboard" placement="bottom">
                                                        <ArrowBackIcon sx={{ fontSize: 20 }} />
                                                    </Tooltip>
                                                </div>
                                                <div className="communityTitle">Domains</div>
                                            </div>
                                            <Grid item sm>
                                                <Button variant="outlined" style={btnGreen} color="primary" onClick={openModal}>
                                                    Add Domain
                                                </Button>
                                            </Grid>
                                        </div>

                                    </Grid>
                                    <Grid container spacing={3} >

                                        <DataTable
                                            data={allDomain}
                                            columns={columns}
                                            isLoading={!isDataLoaded}
                                            initialColumnFilters={[
                                                {
                                                    id: 'isActive',
                                                    value: 'true'
                                                }
                                            ]}
                                        />

                                    </Grid>
                                </>


                                : userType === "" ? (
                                    <div className="row padding_80 text-center">
                                        <p className="fs-semi-bold fs-40 f-color">
                                            Loading...
                                        </p>
                                    </div>
                                ) :
                                    (
                                        <UnauthorizedAccess />
                                    )
                        }
                    </>
                }
            </div>
            <Dialog
                onClose={closeModal}
                aria-labelledby="customized-dialog-title"
                open={modalIsOpen}
                PaperProps={{
                    style: {
                        width: '600px',
                    },
                }}
            >
                <DialogTitle id="customized-dialog-title" className="admindailog_title_modal_domain" onClose={closeModal}>
                    Add Domain
                    <IconButton
                        aria-label="close"
                        style={closeButton}
                        onClick={closeModal}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent >
                    <Typography gutterBottom>
                        Domain*
                    </Typography>
                    <FormControl fullWidth variant="outlined">
                        <OutlinedInput
                            placeholder="Enter Domain"
                            className="admin_textbox"
                            // value={skillName}
                            onChange={domainNamehandlerForadd}
                        />
                    </FormControl>
                    &nbsp;
                    <Typography gutterBottom>
                        Is Active*
                    </Typography>
                    <FormControl fullWidth variant="outlined">
                        <Autocomplete
                            autoSelect
                            id="combo-box-demo"
                            options={v}
                            getOptionLabel={(option) => option.isActive.toString().charAt(0).toUpperCase() + option.isActive.toString().slice(1)}
                            getOptionSelected={(option, value) => option.isActive === value.isActive}
                            renderInput={(params) => <TextField {...params} variant="outlined" placeholder='Select Status' />}
                            onChange={activeHandlerForAdd}
                            onInputChange={activeHandlerAdd}
                        />
                    </FormControl>
                </DialogContent>
                <Grid size={{ xs: 12, md: 12 }} className="user_pop_button" >
                    <DialogActions>
                        <Button variant="outlined" className="btn3" color="primary" onClick={closeModal}>
                            Cancel
                        </Button>
                        <button
                            type="button"
                            className="btn3 btn_primary ml_5 cp"
                            onClick={addDomain}
                            disabled={apvBtn}
                        >
                            <div className="btn_loader">
                                Save
                                &nbsp;
                                {apvBtn &&
                                    <div>
                                        <CircularProgress size={13} />
                                    </div>
                                }
                            </div>
                        </button>
                    </DialogActions>
                </Grid>
            </Dialog>
            {/* ----------- Edit ---------- */}
            <Dialog
                onClose={closeEditmodal}
                aria-labelledby="customized-dialog-title"
                open={modalIsEditopen}
                PaperProps={{
                    style: {
                        width: '600px',
                    },
                }}
            >
                <DialogTitle id="customized-dialog-title" className="admindailog_title_modal_domain" onClose={closeEditmodal}>
                    Edit Domain
                    <IconButton
                        aria-label="close"
                        style={closeButton}
                        onClick={closeEditmodal}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Typography gutterBottom>
                        Domain*
                    </Typography>
                    <FormControl fullWidth variant="outlined">
                        <OutlinedInput
                            // placeholder="Name"
                            className="admin_textbox"
                            defaultValue={modalDataForEdit.name}
                            onChange={domainChangeHandlerForEdit}
                        />
                    </FormControl>
                    &nbsp;
                    <Typography gutterBottom>
                        Is Active*
                    </Typography>
                    <FormControl fullWidth variant="outlined">
                        <Autocomplete
                            autoSelect
                            id="combo-box-demo"
                            options={v}
                            getOptionLabel={(option) => option.isActive.toString().charAt(0).toUpperCase() + option.isActive.toString().slice(1)}
                            value={modalDataForEdit || ""}
                            getOptionSelected={(option, value) => {
                                if (value.isActive === "") {
                                    return option.isActive === true
                                } else {
                                    return option.isActive === value.isActive
                                }
                            }}
                            renderInput={(params) => <TextField {...params} variant="outlined" />}
                            onChange={activeHandlerEdit}
                        />
                    </FormControl>
                </DialogContent>
                <Grid size={{ xs: 12, md: 12 }} className="user_pop_button" >
                    <DialogActions>
                        <Button variant="outlined" className="btn3" color="primary" onClick={closeEditmodal}>
                            Cancel
                        </Button>

                        <button
                            type="button"
                            className="btn3 btn_primary ml_5 cp"
                            onClick={updateDomain}
                            disabled={apvBtn}
                        >
                            <div className="btn_loader">
                                Save
                                &nbsp;
                                {apvBtn &&
                                    <div>
                                        <CircularProgress size={13} />
                                    </div>
                                }
                            </div>
                        </button>
                    </DialogActions>
                </Grid>
            </Dialog>
        </>
    )
}
